import { phraseInfo, tagInfo } from "../constants";
import { processGroupData } from "../../../../../../utils/parseUtils";

export const refinePageList = ({ setPageList, section }) => {
  const allTagList = Object.keys(tagInfo);
  const allPhraseList = Object.keys(phraseInfo);

  let tempPageList = [];
  section.question.data.forEach((element) => {
    const tokens = element.tokens;
    const tokenGroups = processGroupData(element.parsed_syntax.slice()).sort(
      (a, b) =>
        a.token_indices.at(0) - b.token_indices.at(0) === 0
          ? b.token_indices.at(1) - a.token_indices.at(1)
          : a.token_indices.at(0) - b.token_indices.at(0)
    );
    const answerData = tokenGroups
      .filter(
        (group) =>
          allTagList.includes(group.type) || allPhraseList.includes(group.type)
      )
      .map((group) => {
        return {
          type: group.type,
          token_indices: group.token_indices,
          isSubmitted: false,
          isCorrect: null, // Initialize as null, will be set on submission
          studentAnswer: null,
          elementId: null,
          firstAttemptCorrect: null, // Track first attempt result for PDF
          hasBeenAttempted: false // Track if this element has been attempted
        };
      });
    const tagSet = new Set();

    tokenGroups.forEach((group) => {
      const groupType = group.type;
      if (allTagList.includes(groupType) || allPhraseList.includes(groupType)) {
        tagSet.add(groupType);
      }
    });

    const blockList = [];

    tokens.forEach((token, tokenIndex) => {
      {
        blockList.push({
          type: "token",
          text: token.text,
          index: tokenIndex,
          space_right: token.space_right,
        });
      }
    });

    tempPageList.push({
      type: "syntax",
      isSubmitted: false,
      submitCount: 0,
      data: blockList,
      groupData: {},
      phraseData: {},
      answerData: answerData,
      tags: Array.from(tagSet).sort((a, b) => {
        if (allTagList.includes(a) && allTagList.includes(b)) {
          return tagInfo[a].order - tagInfo[b].order;
        } else if (allPhraseList.includes(a) && allPhraseList.includes(b)) {
          return phraseInfo[a].order - phraseInfo[b].order;
        } else if (allTagList.includes(a)) {
          return -1;
        } else {
          return 1;
        }
      }),
      correctnessTracking: {
        totalElements: answerData.length,
        correctElements: 0,
        incorrectElements: 0,
        lastSubmitTime: null,
        level: 'advanced'
      }
    });
  });
  setPageList(tempPageList);
};
